import { getNativeBridge, isNativeLogoutAvailable } from "./nativeBridge";
import { invalidateIOSInstallationAssociation } from "./installationSessionSignal";

/**
 * Best-effort native disassociation during explicit logout.
 *
 * Fire-and-forget by design: native failures must never delay or block
 * the existing web logout flow.
 *
 * SECURITY: never logs an installationId, installationSecret, or FCM
 * token — only the bridge's enumerated `status` field.
 */
export function triggerNativeLogoutIfAvailable() {
  invalidateIOSInstallationAssociation();
  if (!isNativeLogoutAvailable()) {
    return;
  }

  const bridge = getNativeBridge();
  try {
    const maybePromise = bridge.requestLogout();
    if (maybePromise && typeof maybePromise.then === "function") {
      maybePromise
        .then((result) => {
          if (result?.status && result.status !== "completed") {
            console.warn(
              "Native installation disassociation did not complete immediately:",
              result.status
            );
          }
        })
        .catch((error) => {
          console.error(
            "Native requestLogout() rejected unexpectedly:",
            error?.message || error
          );
        });
    }
  } catch (error) {
    // Defensive: logout must never break even if this contract changes.
    console.error(
      "Failed to invoke native requestLogout():",
      error?.message || error
    );
  }
}
